import { Box, Grid, Skeleton, Stack } from "@mui/material";

export const TaxesModalSkeleton = () => {
  return (
    <Box p={2}>
      <Grid container spacing={2}>
        {/* Code */}
        <Grid item xs={12} md={6}>
          <Skeleton width={60} height={24} />
          <Skeleton variant="rectangular" height={40} />
        </Grid>

        {/* Tax Type */}
        <Grid item xs={12} md={6}>
          <Skeleton width={80} height={24} />
          <Skeleton variant="rectangular" height={40} />
        </Grid>

        {/* Description */}
        <Grid item xs={12}>
          <Skeleton width={90} height={24} />
          <Skeleton variant="rectangular" height={80} />
        </Grid>

        {/* Rate */}
        <Grid item xs={12} md={6}>
          <Skeleton width={70} height={24} />
          <Skeleton variant="rectangular" height={40} />
        </Grid>

        {/* Switch */}
        <Grid item xs={12} md={6}>
          <Skeleton width={120} height={24} />
          <Skeleton
            variant="rectangular"
            width={42}
            height={24}
            sx={{ mt: 1 }}
          />
        </Grid>
      </Grid>

      {/* Footer Buttons */}
      <Stack direction="row" spacing={1} justifyContent="flex-end" mt={3}>
        <Skeleton variant="rectangular" width={80} height={36} />
        <Skeleton variant="rectangular" width={80} height={36} />
      </Stack>
    </Box>
  );
};
